import { FC, useContext, useEffect, useState } from 'react';
import EventInfo from './EventInfo';
import PPGSelection from './PPGSelection';
import { TPODataContext } from 'contexts/TPOContext';
import { Form } from 'antd';
import { FormInstance } from 'antd/es/form';
import { queryClient } from 'services/reactQueryService';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { AttributesPromoMapping } from 'types/tradePromoOptimization';

type Props = {
    open: boolean;
    eventId: string | null;
    form: FormInstance<any>;
    disabledEvent: boolean;
    nestedAttributePromoMapping: AttributesPromoMapping;
    calenderDataCount: number;
};

const EventDetails: FC<Props> = ({
    open,
    form,
    eventId,
    disabledEvent,
    nestedAttributePromoMapping,
    calenderDataCount,
}) => {
    //context
    const { selectedEventInfo, selectedPlanInfo } = useContext(TPODataContext);
    const { appConfig } = useContext(UserContext);
    const tradePromoOptimizationConfig = getConfig('tradePromoOptimization', appConfig);
    //update local state with context state when popup opens
    useEffect(() => {
        if (open && selectedEventInfo) {
            const {
                name,
                displayACV,
                featureACV,
                // offerMethod,
                // CRADuration,
                // offer,
                // offerType,
                // offerTypeUnit,
                // par,
                // newStatus,
                // promoGrouping,
                CRAStartDate,
                CRAEndDate,
                selectedDim1Attributes,
                selectedDim1NestedAttributes,
            } = selectedEventInfo ?? {};
            form.resetFields();
            //setting default value
            form.setFieldsValue({
                displayACV: tradePromoOptimizationConfig?.defaultDisplayACV,
                featureACV: tradePromoOptimizationConfig?.defaultFeatureACV,
                name: `Event_${selectedPlanInfo?.dim1Filter?.value?.join('_')}_${Math.max(1, calenderDataCount + 1)}`,
            });
            //if eventid present, then it means its coming from edit flow
            if (eventId) {
                //setting values in form
                form.setFieldsValue({
                    name,
                    displayACV,
                    featureACV,
                    // offerMethod,
                    // CRADuration,
                    // offer,
                    // par,
                    // newStatus,
                    // promoGrouping,
                    // offerType,
                    // offerTypeUnit,
                    CRAStartDate,
                    CRAEndDate,
                    selectedDim1Values: selectedDim1Attributes,
                    selectedDim1NestedValues: selectedDim1NestedAttributes,
                });
            }
        }

        //clear queries when popup is closed
        return () => {
            queryClient.removeQueries({
                exact: false,
                queryKey: ['tpo-fetch-offer-data'],
            });
            queryClient.removeQueries({
                exact: false,
                queryKey: ['tpo-events-get-attribute-types'],
            });
        };
    }, [open]);

    return (
        <div className="flex gap-4 h-[620px] ">
            <PPGSelection
                nestedAttributePromoMapping={nestedAttributePromoMapping}
                disabledEvent={disabledEvent}
                eventId={eventId}
                form={form}
                open={open}
            />
            <EventInfo disabledEvent={disabledEvent} form={form} />
        </div>
    );
};

export default EventDetails;
